import { APIService } from '../api/APIService';
import moment from 'moment-timezone';
import { TIMEZONE } from '../../utils/constants';

export class AvailabilityService {
  path: string;
  apiService: APIService;

  constructor(apiService: APIService) {
    const availabilityURI = import.meta.env.VITE_DS_AVAILABILITY_API;
    if (!availabilityURI) {
      throw new Error('No availability api uri path set');
    }
    this.path = availabilityURI;
    this.apiService = apiService;
  }

  getFirstAvailability(geoareaID: number): Promise<endpoints.LessonTime[]> {
    const params = { geoareaID };
    return this.apiService.getData(this.path, params);
  }

  getAvailabilityForDay(geoareaID: number, date: Date): Promise<endpoints.LessonTime[]> {
    const dateString = moment(date).tz(TIMEZONE).format('YYYY-MM-DD');
    const params = { geoareaID, date: dateString };
    return this.apiService.getData(this.path, params);
  }
}
